import * as React from "react";
import { selectResourceInfo } from "../../balancingSelectors/selectBalancingResources";
import { IdStyles } from "../../less/IdStyles";
import { FontWithOutline } from "../generic/font-with-outline/FontWithOutline";
import { ResourceIcon } from "../generic/icon/ResourceIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../generic/number-format/TypeNumberFormat";
export var RewardStoreResources = function (_a) {
    var rewards = _a.rewards, backgroundClassName = _a.backgroundClassName;
    var rewardElements = rewards.resourceRewards.map(function (resource) {
        var typeId = resource.typeId;
        var amount = resource.amount;
        var resourceInfo = selectResourceInfo(typeId);
        return (React.createElement("div", { className: "flex flex--guts flex--stacked", key: typeId },
            React.createElement(ResourceIcon, { resource: resourceInfo, styleId: IdStyles.IconExtraLarge }),
            React.createElement(FontWithOutline, { style: IdStyles.TextBoldSecondaryOutline },
                React.createElement(NumberFormat, { amount: amount, format: TypeNumberFormat.None }))));
    });
    return React.createElement("div", { className: backgroundClassName + " flex flex--guts" }, rewardElements);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/store/RewardStoreResources.tsx
// module id = 951
// module chunks = 3